const BRANCH_PREVIEW_HOST = 'work-mobile-practice-ui-parity-dororaid.kukla1255.workers.dev';
const COMMIT_PREVIEW_HOST = /^[a-f0-9]{8}-dororaid\.kukla1255\.workers\.dev$/;

function currentLocation() {
  return typeof window === 'undefined' ? null : window.location;
}

function allowedPreviewHost(hostname) {
  const normalized = String(hostname || '').trim().toLowerCase();
  return normalized === 'localhost'
    || normalized === '127.0.0.1'
    || normalized === BRANCH_PREVIEW_HOST
    || COMMIT_PREVIEW_HOST.test(normalized);
}

export function isRaidPracticeMockOnlyPreview(locationValue = currentLocation()) {
  if (!locationValue || !allowedPreviewHost(locationValue.hostname)) return false;
  const params = new URLSearchParams(String(locationValue.search || ''));
  return params.get('practicePreview') === 'mock-only';
}

export function raidPracticeActualRecordsForDisplay(records = [], locationValue = currentLocation()) {
  if (isRaidPracticeMockOnlyPreview(locationValue)) return [];
  return Array.isArray(records) ? records : [];
}

export function assertRaidPracticePreviewWritable(locationValue = currentLocation()) {
  if (!isRaidPracticeMockOnlyPreview(locationValue)) return;
  const error = new Error('모의전 확인 모드에서는 기록을 변경할 수 없습니다.');
  error.code = 'practice_preview_read_only';
  throw error;
}
